import createApi from './api';

export default class CameraViewService {
  constructor() {
    this.reportsApi = createApi({
      baseUrl: `reports`,
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async getImages(params) {
    if ('hw_id' in params && params['hw_id']) {
      return this.devicesApi.post('screenshots', params);
    } else {
      return this.reportsApi.post('screenshots', params);
    }
  }
}
